import { cloneDeep } from 'lodash';

import {
  getAuthFromCookie,
  clearExtraAliasInfo,
  getCookieValue,
} from '../../utils/cookie';
import { withClientToken } from '../../actions/helpers/tokenHelpers';
import { updatePassword } from '../../actions/sagAuth';
import getPlatformUrl from '../../utils/login';
import {tokenSelector} from "../../selectors/auth";

const INIT = 'newPassword/INIT';
const SET_FIELDS = 'newPassword/SET_FIELDS';
const SET_ERROR = 'newPassword/SET_ERROR';
const SET_SUCCESS = 'newPassword/SET_SUCCESS';
const SET_SUBMITTING = 'newPassword/SET_SUBMITTING';
const SET_VALIDATION_TXT = 'newPassword/SET_VALIDATION_TXT';

const defaultState = {
  fields: { password: '', password2: '' },
  errorMessage: '',
  successMessage: '',
  submitting: false,
  validationTxt: {},
};

const setFields = fields => ({ type: SET_FIELDS, fields });

const setError = err => ({ type: SET_ERROR, err });

const setSuccess = successMessage => ({ type: SET_SUCCESS, successMessage });

const setSubmitting = bool => ({ type: SET_SUBMITTING, bool });

const setValidationTxt = txt => ({ type: SET_VALIDATION_TXT, txt });

const setFieldsVal = (field, val) => (dispatch, getState) => {
  const { fields } = getState().routes.newPassword;

  const clonedFields = cloneDeep(fields);

  clonedFields[field] = val;

  dispatch(setFields(clonedFields));
};

// const redirectToSubdomain = () => (dispatch, getState) => {
//   console.log('++++++++++++++++++++++', getState())
//   const { auth: {user} } = getState().routes;
//
//
//   const redirectUrl = getPlatformUrl({
//     organizationSubdomain: user.subdomain_url,
//     websiteHost: window.location.host,
//   });
//
//   clearExtraAliasInfo();
//   window.location.replace(redirectUrl);
// };

const submitPassword = () => async (dispatch, getState) => {
  const { fields, submitting } = getState().routes.newPassword;

  const { password, password2 } = fields;

  const errors = [];

  if (!password) {
    dispatch(setError('Password cannot be empty'));
    return;
  }

  if (!password2) {
    dispatch(setError('Confirm password cannot be empty'));
    return;
  }

  if (password && password2 && password !== password2) {
    dispatch(setError("Passwords don't match"));
    return;
  }

  if (password && !/^.{10,}$/i.test(password)) {
    errors.push('Password must at least be 10 characters in length');
    dispatch(setError(errors.join('/r/n')));
    return;
    // errors.push('Password must at least be 10 characters in length');
  }

  if (password && !/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)) {
    errors.push('Password must contain at least one special case character');
    dispatch(setError(errors.join('/r/n')));
    return;
    // errors.push('Password must at least be 10 characters in length');
  }

  if (password && !/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one upper case letter');
    dispatch(setError(errors.join('/r/n')));
    return;
    // errors.push('Password must at least be 10 characters in length');
  }

  if (password && !/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lower case letter');
    dispatch(setError(errors.join('/r/n')));
    return;
    // errors.push('Password must at least be 10 characters in length');
  }
  if (password && !/[0-9]/.test(password)) {
    errors.push('Password must contain at least one digit');
    dispatch(setError(errors.join('/r/n')));
    return;
    // errors.push('Password must at least be 10 characters in length');
  }

  const extraAliasInfo = getCookieValue('extra_alias_info');

  if (extraAliasInfo) {
    const parsedExtraAliasInfo = JSON.parse(extraAliasInfo);

    const { passwordRegex, validationTxt } = parsedExtraAliasInfo;

    const correctPass = RegExp(passwordRegex).test(password);

    if (!correctPass) {
      dispatch(setValidationTxt(validationTxt));
      return;
    }
  }

  if (submitting) {
    return;
  }

  dispatch(setSubmitting(true));

  try {
    const userToken = tokenSelector(getState().routes);

    const { error, errorCode } = await withClientToken({
      action: updatePassword,
      args: [userToken, password, password2],
    });

    console.log({ error, errorCode });

    if (error) {
      dispatch(setSubmitting(false));
      dispatch(setError(error.errorMessage));
      return;
    }

    // const {
    //   refresh_token: refreshToken,
    //   subdomain_url: subdomain,
    //   user_token: userToken,
    //   id: userId,
    // } = data;

    // const user = merge({}, data, { user_id: userId });
    // delete user.user_token;
    // delete user.refresh_token;
    // delete user.redirection_token;
    // delete user.id;

    // saveAuthCookie(userToken, refreshToken, user, subdomain, true);

    // dispatch(setError(''));
    // const { auth: {user} } = getState().routes;
    //
    //
    // const redirectUrl = getPlatformUrl({
    //   organizationSubdomain: user.subdomain_url,
    //   websiteHost: window.location.host,
    // });
    //
    // clearExtraAliasInfo();
    // window.location.replace(redirectUrl);
    dispatch(setSubmitting(false));
    dispatch(setError(''));
    dispatch(setFields({password: '', password2: ''}));
    dispatch(setSuccess('Password changed successfully'));
    setTimeout(() => {
      window.location.replace('/sign-in');
    }, 3000)

  } catch (err) {
    dispatch(setSubmitting(false));
    dispatch(setError('Some error occured'));
  }
};

export const ACTIONS = {
  init: () => ({ type: INIT }),
  setFieldsVal,
  submitPassword,
};

function newPassword(state = defaultState, action) {
  switch (action.type) {
    case INIT:
      return Object.assign({}, state);
    case SET_FIELDS:
      return Object.assign({}, state, {
        fields: action.fields,
      });
    case SET_ERROR:
      return Object.assign({}, state, {
        errorMessage: action.err,
      });
    case SET_SUCCESS:
      return Object.assign({}, state, {
        successMessage: action.successMessage,
      });
    case SET_SUBMITTING:
      return Object.assign({}, state, {
        submitting: action.bool,
      });
    case SET_VALIDATION_TXT:
      return Object.assign({}, state, {
        validationTxt: action.txt,
      });
    default:
      return Object.assign({}, state);
  }
}

export default newPassword;



// WEBPACK FOOTER //
// ./src/reducers/routeReducers/newPassword.js